document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.getElementById("js-icon-search");
  if (!searchInput) return;

  const countEl = document.getElementById("js-icon-count");
  const source = document.getElementById("js-icons-source");
  const exactSection = document.getElementById("js-exact-section");
  const exactGrid = document.getElementById("js-icons-exact");
  const closeSection = document.getElementById("js-close-section");
  const closeGrid = document.getElementById("js-icons-close");
  const items = Array.from(source.querySelectorAll(".js-icon-item"));

  function levenshtein(source, target) {
    const sourceLen = source.length;
    const targetLen = target.length;
    const dp = Array.from({ length: sourceLen + 1 }, (_, row) => [row, ...Array(targetLen).fill(0)]);
    for (let col = 0; col <= targetLen; col++) dp[0][col] = col;
    for (let row = 1; row <= sourceLen; row++)
      for (let col = 1; col <= targetLen; col++)
        dp[row][col] =
          source[row - 1] === target[col - 1]
            ? dp[row - 1][col - 1]
            : 1 + Math.min(dp[row - 1][col], dp[row][col - 1], dp[row - 1][col - 1]);
    return dp[sourceLen][targetLen];
  }

  function classify(query, item) {
    const text = item.dataset.name + "," + item.dataset.aliases;
    if (text.includes(query)) return "exact";
    if (query.length < 3) return null;
    const maxDist = query.length <= 5 ? 1 : 2;
    return text.split(/[\s,-]+/).some((word) => levenshtein(query, word) <= maxDist) ? "close" : null;
  }

  function updateCount(count) {
    countEl.textContent = count + " / " + items.length + " icons";
  }

  updateCount(items.length);

  searchInput.addEventListener("input", function () {
    const query = this.value.toLowerCase().trim();

    if (!query) {
      items.forEach((item) => {
        item.style.display = "";
        source.appendChild(item);
      });
      source.style.display = "";
      exactSection.style.display = "none";
      closeSection.style.display = "none";
      updateCount(items.length);
      return;
    }

    source.style.display = "none";
    let exactCount = 0;
    let closeCount = 0;

    items.forEach((item) => {
      item.style.display = "";
      const bucket = classify(query, item);
      if (bucket === "exact") {
        exactGrid.appendChild(item);
        exactCount++;
      } else if (bucket === "close") {
        closeGrid.appendChild(item);
        closeCount++;
      } else {
        exactGrid.appendChild(item);
        item.style.display = "none";
      }
    });

    exactSection.style.display = exactCount > 0 ? "" : "none";
    closeSection.style.display = closeCount > 0 ? "" : "none";
    updateCount(exactCount + closeCount);
  });
});
